import { render } from "./PopoversContent.vue?vue&type=template&id=52ccdbe0"
import script from "./PopoversContent.vue?vue&type=script&lang=js"
export * from "./PopoversContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__